import 'common/scripts/polyfills';
import {
    fixPopupHeader,
    initCallbackForm,
    initCallbackPopups
} from 'common/scripts/common';
import App from './App.vue';
import router from './router';
import store from './store';
import Vue from 'vue';

Vue.config.productionTip = false;

Vue.prototype.$appOptions = {
    overlay: {
        default: 0.3,
        hover  : 0.6,
        floor  : 0.3
    }
};

const el = '#visual';
const visualEl = document.querySelector(el);
const complexId = visualEl ? visualEl.dataset.complexId || false : false;

router.beforeEach((to, from, next) => {
    if (!to.params.hasOwnProperty('complexId') && complexId) {
        to.params.complexId = complexId;
    }
    next();
});

new Vue({
    router,
    store,
    render: (h) => {
        return h(App);
    }
}).$mount(el);

// Поведение меню
const headerWrap = document.querySelector('.j-header');

// Попапы обратной связи и инциализация формы
const popupLinks = Array.from(document.querySelectorAll('.j-popup-callback-call'));

if (popupLinks.length) {
    initCallbackPopups(popupLinks);
    initCallbackForm();
}

// При открытии попапа сдвигаем шапку на ширину сколл-бара.
fixPopupHeader(headerWrap);

const setModifyFooter = () => {
    const footer = document.querySelector('.j-page-footer');
    const upButton = document.querySelector('.j-up-button');

    if (footer) {
        footer.style.display = 'none';
    }

    if (upButton) {
        upButton.style.display = 'none';
    }
};

setModifyFooter();

const modifyHeader = () => {
    const header = document.querySelector('.j-header');

    if (header) {
        header.classList.add('header_theme_fixed');
        header.classList.add('header_theme_special');
        header.classList.remove('header_theme_blue');
    }
};

modifyHeader();

